import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
const appendUnit = (value) => (typeof value === 'string' ? value : `${value}px`);
const StyledSVG = styled('svg').attrs(props => {
    var _a;
    // React 19 dropped runtime defaultProps for function components (styled components are
    // function components), so the previous `StyledSVG.defaultProps = {size: 20}` no longer
    // applies. The default only ever fed the width/height calculation, so we apply it here.
    const size = (_a = props.size) !== null && _a !== void 0 ? _a : 20;
    return {
        width: `${props.width !== undefined ? props.width : size}px`,
        height: `${props.height !== undefined ? props.height : size}px`,
        version: '1.1',
        xmlns: 'http://www.w3.org/2000/svg',
    };
}) `
    background: ${props => (props.background ? props.background : 'initial')};
    border-radius: ${props => (props.radius ? appendUnit(props.radius) : 'initial')};
    vertical-align: initial;
    ${props => (props.inline ? 'display: inline-block;' : '')}
`;
export const SVG = React.memo((props) => {
    return _jsx(StyledSVG, { ...props });
});
const getFill = (appearance, theme) => {
    switch (appearance) {
        case 'white':
            return theme.invertedText;
        case 'accent1':
            return theme.accent1;
        default:
            return theme.text;
    }
};
export const G = styled('g') `
    fill: ${props => {
    if (props.fill) {
        return props.fill;
    }
    if (props.color) {
        return props.color;
    }
    if (props.appearance) {
        return getFill(props.appearance, props.theme);
    }
    return props.theme.text;
}};
`;
